import type { Game } from "../../data/games";
import { useCarouselPosition } from "../../hooks/useCarouselPosition";
import { FeaturedGameCard } from "../FeaturedGameCard/FeaturedGameCard";
import { PagerIndicator } from "../PagerIndicator/PagerIndicator";
import styles from "./FeaturedCarousel.module.css";

interface FeaturedCarouselProps {
  games: readonly Game[];
  onSelectGame: (game: Game, trigger: HTMLButtonElement) => void;
}

export function FeaturedCarousel({
  games,
  onSelectGame,
}: FeaturedCarouselProps) {
  const { carouselRef, currentIndex, scrollToIndex, handleKeyDown } =
    useCarouselPosition(games.length);

  return (
    <section className={styles.section} aria-labelledby="featured-heading">
      <div className={styles.headingRow}>
        <div>
          <span className={styles.eyebrow}>Kvällens favoriter</span>
          <h2 id="featured-heading">Populärt just nu</h2>
        </div>
        <span className={styles.count}>{games.length} spel</span>
      </div>

      <div
        className={styles.carousel}
        ref={carouselRef}
        tabIndex={0}
        role="region"
        aria-roledescription="carousel"
        aria-label="Populära spel. Använd vänster- och högerpil för att bläddra."
        onKeyDown={handleKeyDown}
      >
        {games.map((game, index) => (
          <div
            className={styles.item}
            key={game.id}
            data-carousel-item
            aria-label={`${index + 1} av ${games.length}`}
          >
            <FeaturedGameCard
              game={game}
              priority={index === 0}
              onSelect={onSelectGame}
            />
          </div>
        ))}
      </div>

      <PagerIndicator
        count={games.length}
        currentIndex={currentIndex}
        onSelect={scrollToIndex}
      />
    </section>
  );
}
